"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let t = 0;
class Request {
    constructor() {
        this.type = 'top-trading-signals';
        const { request } = require('@futuweb/fego-render').common;
        this.commonApi = request.bindCommonApi(this.type);
    }
    /** 获取信号选股结果，传入 signal key */
    async getSignalSelectedStocks(params) {
        return await this.commonApi.get('signal_selected_stocks', params);
    }
    /** 获取个股评级变动结果，传入 actSign 和 module */
    async getRatingSelectedStocks(params) {
        return await this.commonApi.get('rating_selected_stocks', params);
    }
    /** 获取头部分析师选股结果，传入 actSign */
    async getAnalystUpdates(params) {
        return await this.commonApi.get('analyst_updates', params);
    }
    /** 获取个股 AI 分析报告，传入 stockId 列表，逗号分隔 */
    async getAiStockAnalysis(params) {
        return await this.commonApi.get('get_ai_stock_analysis', params);
    }
}
exports.default = new Request();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJlcXVlc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFVQSxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUM7QUFFVixNQUFNLE9BQU87SUFJVDtRQUhBLFNBQUksR0FBRyxxQkFBcUIsQ0FBQztRQUl6QixNQUFNLEVBQUUsT0FBTyxFQUFFLEdBQUcsT0FBTyxDQUFDLHNCQUFzQixDQUFDLENBQUMsTUFBTSxDQUFDO1FBQzNELElBQUksQ0FBQyxTQUFTLEdBQUcsT0FBTyxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdEQsQ0FBQztJQUVELDZCQUE2QjtJQUM3QixLQUFLLENBQUMsdUJBQXVCLENBQUMsTUFBbUM7UUFDN0QsT0FBTyxNQUFNLElBQUksQ0FBQyxTQUFTLENBQUMsR0FBRyxDQUFDLHdCQUF3QixFQUFFLE1BQU0sQ0FBQyxDQUFDO0lBQ3RFLENBQUM7SUFFRCxxQ0FBcUM7SUFDckMsS0FBSyxDQUFDLHVCQUF1QixDQUFDLE1BQW1DO1FBQzdELE9BQU8sTUFBTSxJQUFJLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyx3QkFBd0IsRUFBRSxNQUFNLENBQUMsQ0FBQztJQUN0RSxDQUFDO0lBRUQsNkJBQTZCO0lBQzdCLEtBQUssQ0FBQyxpQkFBaUIsQ0FBQyxNQUE2QjtRQUNqRCxPQUFPLE1BQU0sSUFBSSxDQUFDLFNBQVMsQ0FBQyxHQUFHLENBQUMsaUJBQWlCLEVBQUUsTUFBTSxDQUFDLENBQUM7SUFDL0QsQ0FBQztJQUVELHNDQUFzQztJQUN0QyxLQUFLLENBQUMsa0JBQWtCLENBQUMsTUFBOEI7UUFDbkQsT0FBTyxNQUFNLElBQUksQ0FBQyxTQUFTLENBQUMsR0FBRyxDQUFDLHVCQUF1QixFQUFFLE1BQU0sQ0FBQyxDQUFDO0lBQ3JFLENBQUM7Q0FDSjtBQUVELGtCQUFlLElBQUksT0FBTyxFQUFFLENBQUMifQ==